export { MyImage, MotionMyImage } from './MyImage';
